import { Box, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { useState } from 'react';

const Selects = () => {
  const [selectedValue, setSelectedValue] = useState('');
  const nameOptions = [
    { label: 'John Doe', value: 'john' },
    { label: 'Jane Doe', value: 'jane' },
    { label: 'Sam Smith', value: 'sam' },
  ];

  return (
    <Box>
      <Typography variant="h3">Select</Typography>
      <Box gap={2} mt={2} alignItems={'flex-end'}>
        <InputLabel>Name</InputLabel>
        <Select
          name="name"
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
          displayEmpty
          fullWidth
        >
          <MenuItem value="" disabled>
            Please Select Name
          </MenuItem>
          {nameOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default Selects;
